/* Audio Monkey — premium collection list behaviours.
   Loaded deferred, after am-draft-fixes.js. Everything here is delegated from
   `document`, so it survives the AJAX section swaps the theme performs on
   filter / sort / load-more without needing to re-bind anything.

   Scope: the premium card only (`.am-card`, list AND grid as of runda 9).
   Must not affect search or the theme's own product-item cards. */
/* Ported 2026-07-29 from TUDOR - TEST (198632866127) onto "AM26 PDP +
   pachete" WITHOUT the third module of the original file — the
   "Compară produse" tray/panel. Compare is deliberately not on this
   theme (separate discussion with Tudor before it ships anywhere);
   its locale keys, CSS and card checkbox are likewise absent. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Colour swatch hover preview (Tudor request, 2026-07-26)
     Hovering a colour swatch updates the "Selecție:" label and swaps the
     large product image to that colour. Leaving the swatch list restores
     the original. Clicking still navigates to the variant URL, so the
     behaviour is additive — nothing depends on JS to be usable.
     ------------------------------------------------------------------ */

  var ORIGINAL = new WeakMap();
  /* contorul de cereri per card — vezi comentariul din preview() */
  var PENDING = new WeakMap();

  function cardOf(el) {
    return el.closest ? el.closest('.am-card') : null;
  }

  function preview(card, name, imgSrc) {
    if (!card) return;

    var label = card.querySelector('.am-card__options-current');
    var img = card.querySelector('.am-card__img');

    if (!ORIGINAL.has(card)) {
      ORIGINAL.set(card, {
        name: label ? label.textContent : null,
        // srcset must be cleared while previewing, otherwise the browser keeps
        // choosing a candidate from the original set and the swap looks broken
        // on high-DPI screens.
        src: img ? img.getAttribute('src') : null,
        srcset: img ? img.getAttribute('srcset') : null
      });
    }

    /* Invalidăm ORICE cerere în zbor ÎNAINTE de orice ieşire timpurie
       (corecţie 2026-08-25, review Codex). Versiunea dinainte incrementa
       token-ul abia mai jos, DUPĂ `return`-ul pentru swatch-urile fără
       `data-am-img` (variante fără `featured_media` — Liquid omite atributul).
       Consecinţa: hover pe A (cu poză) → hover pe B (fără poză) lăsa cererea
       lentă a lui A încă „curentă", deci poza A putea ateriza sub eticheta B. */
    var token = (PENDING.get(card) || 0) + 1;
    PENDING.set(card, token);

    if (label && name) label.textContent = name;
    if (!img || !imgSrc) return;

    /* AM 2026-08-25 (Tudor: „cand fac hover pe color variant nu imi arata
       preview la culoare... dar daca iau mouse-ul de pe preview si dupa pun
       iar, atunci functioneaza").

       CAUZA, măsurată live pe /collections/bang-olufsen: swap-ul se aplica
       DE FIECARE DATĂ, inclusiv la primul hover — dar imaginea culorii nu era
       încă descărcată. Pe Beoplay EX / „Anthracite Oxygen", necached:
       `complete:false, naturalWidth:0` imediat după hover, gata abia după
       ~800ms. A doua oară venea din cache în 3ms, de-aici „a doua oară merge".
       Versiunea veche golea `srcset` ŞI scria `src` în aceeaşi clipă, deci în
       fereastra aia <img> n-avea NIMIC de afişat.

       Fix: schimbăm atributele abia când noua imagine e efectiv decodată.
       Până atunci rămâne poza precedentă — niciodată gol. `decode()` e exact
       unealta pentru asta; fallback pe onload unde nu există.

       `token` protejează împotriva curselor: dacă utilizatorul trece rapid
       peste trei culori, doar ultima cerută are voie să scrie în <img>, altfel
       o descărcare mai lentă pornită prima ar ateriza peste cea aleasă ulterior. */
    var next = new Image();
    next.src = imgSrc;

    var apply = function () {
      if (PENDING.get(card) !== token) return;   // a cerut între timp altă culoare
      if (!ORIGINAL.has(card)) return;           // a ieşit de pe card între timp
      img.setAttribute('srcset', '');
      img.setAttribute('src', imgSrc);
    };

    /* Aşteptăm `onload`, NU `decode()`. `decode()` pare unealta potrivită, dar
       măsurat pe /collections/casti nu se stabiliza niciodată în acest motor
       (imaginea era `complete:true, naturalWidth:480`, iar promisiunea rămânea
       nerezolvată după 4s) — adică swap-ul n-ar mai fi ajuns niciodată să se
       aplice. `onload` + `complete` sunt suficiente: imaginea e descărcată,
       iar pictarea o face browserul la următorul frame.

       Plasă de siguranţă pe timp: dacă `onload` nu vine în 3s (reţea moartă,
       URL greşit), ABANDONĂM definitiv — desprindem handlerele şi marcăm
       cererea ca încheiată, ca o sosire ulterioară să nu mai poată repicta.
       <img> rămâne pe poza veche, exact comportamentul dorit.

       Corecţie 2026-08-25 (review Codex): prima versiune verifica la 3s
       `next.complete && naturalWidth > 0` şi APLICA — adică nu renunţa
       niciodată; dacă imaginea sosea la secunda 10, tot se aplica. Nu era
       „timeout", cum scria comentariul. */
    if (next.complete && next.naturalWidth > 0) {
      apply();
      return;
    }
    var settled = false;
    var timer = null;
    var finish = function (run) {
      if (settled) return;
      settled = true;
      if (timer) { clearTimeout(timer); timer = null; }
      next.onload = null;
      next.onerror = null;
      if (run) apply();
    };
    next.onload = function () { finish(true); };
    next.onerror = function () { finish(false); };   // păstrăm poza veche
    timer = setTimeout(function () { finish(false); }, 3000);
  }

  function restore(card) {
    /* Invalidează orice descărcare pornită şi neaterizată: fără asta, o
       imagine cerută înainte de ieşirea de pe card ar putea sosi DUPĂ restore
       şi ar repicta culoarea de preview peste cea reală. */
    if (card) PENDING.set(card, (PENDING.get(card) || 0) + 1);
    if (!card || !ORIGINAL.has(card)) return;
    var original = ORIGINAL.get(card);
    var label = card.querySelector('.am-card__options-current');
    var img = card.querySelector('.am-card__img');

    if (label && original.name !== null) label.textContent = original.name;
    if (img && original.src) {
      img.setAttribute('src', original.src);
      if (original.srcset === null) {
        img.removeAttribute('srcset');
      } else {
        img.setAttribute('srcset', original.srcset);
      }
    }
    ORIGINAL.delete(card);
  }

  function onEnter(event) {
    var link = event.target.closest && event.target.closest('.am-card__swatch a');
    if (!link) return;
    preview(cardOf(link), link.getAttribute('data-am-name'), link.getAttribute('data-am-img'));
  }

  function onLeave(event) {
    var list = event.target.closest && event.target.closest('.am-card__swatches');
    if (!list) return;
    // Only restore when the pointer has actually left the whole swatch list,
    // not while moving between two adjacent swatches.
    if (event.relatedTarget && list.contains(event.relatedTarget)) return;
    restore(cardOf(list));
  }

  /* Safety net (2026-07-29): leaving the CARD always restores it, whatever the
     swatch-level handler did. `mouseout` reports relatedTarget === null when the
     pointer leaves the window, jumps to a cross-origin iframe (the chat widget
     sits over these cards), or when the element under it is removed mid-gesture
     — in those cases the check above returns early and the preview used to stay
     applied, leaving the label and image describing a variant the shopper is no
     longer pointing at. Restoring an untouched card is a no-op: `restore()`
     returns immediately unless ORIGINAL holds a snapshot for it. */
  function onCardLeave(event) {
    var card = event.target.closest && event.target.closest('.am-card');
    if (!card) return;
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    restore(card);
  }

  /* Preîncărcarea culorilor la intrarea pe CARD (Tudor, 2026-08-25).
     Motivul e în comentariul din preview(): prima trecere peste un swatch
     trebuia să aştepte descărcarea (~800ms măsurat), a doua venea din cache
     (3ms). Când mouse-ul ajunge pe card, utilizatorul mai are câteva sute de
     milisecunde până coboară la swatch-uri — exact fereastra în care putem
     aduce fişierele, ca primul hover să fie la fel de rapid ca al doilea.

     Doar la intrarea pe card, NU la încărcarea paginii: pe colecţia B&O sunt
     108 imagini de preview în 40 de carduri; aduse toate la load ar concura cu
     imaginile principale şi ar strica LCP-ul. Aşa, se descarcă doar pentru
     cardurile pe care utilizatorul chiar trece.

     Doar swatch-urile RANDATE: cele ascunse în spatele „+N" nu pot fi
     hover-uite, deci n-au ce prelua. `offsetParent` e verificarea ieftină de
     vizibilitate (null pentru `display:none`).

     Se face o singură dată per card (`PRELOADED`), iar `Image()` nu ataşează
     nimic în DOM — browserul doar populează cache-ul HTTP. */
  var PRELOADED = new WeakSet();

  function preloadCard(card) {
    if (!card || PRELOADED.has(card)) return;
    PRELOADED.add(card);
    var links = card.querySelectorAll('.am-card__swatch a[data-am-img]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.offsetParent) continue;             // ascuns sub „+N": nu se poate hover
      var url = a.getAttribute('data-am-img');
      if (url) { var im = new Image(); im.src = url; }
    }
  }

  function onCardEnter(event) {
    var card = event.target.closest && event.target.closest('.am-card');
    if (!card) return;
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    preloadCard(card);
  }

  // Pointer. `mouseover`/`mouseout` bubble, unlike mouseenter/mouseleave.
  document.addEventListener('mouseover', onCardEnter);
  document.addEventListener('mouseover', onEnter);
  document.addEventListener('mouseout', onLeave);
  document.addEventListener('mouseout', onCardLeave);

  // Keyboard parity: the same preview on focus, so the interaction is not
  // mouse-only. focusin/focusout bubble; focus/blur do not.
  document.addEventListener('focusin', function (event) {
    /* paritate cu mouse-ul: şi navigarea din tastatură beneficiază de preload */
    var card = event.target.closest && event.target.closest('.am-card');
    if (card) preloadCard(card);
  });
  document.addEventListener('focusin', onEnter);
  document.addEventListener('focusout', function (event) {
    var list = event.target.closest && event.target.closest('.am-card__swatches');
    if (!list) return;
    if (event.relatedTarget && list.contains(event.relatedTarget)) return;
    restore(cardOf(list));
  });

  // Touch devices fire a synthetic mouseover before the click; without this the
  // preview would stick after navigation is cancelled or the user scrolls away.
  document.addEventListener('touchend', function (event) {
    var list = event.target.closest && event.target.closest('.am-card__swatches');
    if (!list) restore(cardOf(event.target));
  }, { passive: true });
})();

/* ------------------------------------------------------------------
   "Mai multe detalii" disclosure (mobile only)
   Progressive enhancement: the button is hidden by CSS until this script
   marks the card `data-am-ready`. With JS unavailable the button never
   appears and the highlights stay visible, so no content is ever trapped
   behind a control that cannot be operated.
   Delegated from `document`, so it survives the theme's AJAX section swaps.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function markReady(root) {
    (root || document).querySelectorAll('.am-card:has(.am-card__more), .am-card .am-card__more')
      .forEach(function (el) {
        var card = el.classList.contains('am-card') ? el : el.closest('.am-card');
        if (card) card.setAttribute('data-am-ready', '');
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.am-card__more');
    if (!btn) return;
    var card = btn.closest('.am-card');
    if (!card) return;
    var list = card.closest('.l4cl');
    var open = card.hasAttribute('data-am-more');
    // `data-am-anim` arms the CSS transition (2026-08-05). Without it the panel
    // has NO transition, which is what makes the collapsed state the first thing
    // painted: `data-am-ready` is only set at DOMContentLoaded, so the panel's
    // first computed state is the OPEN one and the collapse used to run as an
    // animation — every page load flashed the full bullet list before closing
    // it. Measured on /collections/casti at 390px, that animation could also sit
    // stuck at 400px, which threw the grid's "Adauga in cos" buttons out of line
    // by up to 244px. Armed here, on a real click, so the open/close stays as
    // slow and smooth as Tudor asked for.
    card.setAttribute('data-am-anim', '');
    // Only one card's disclosure open at a time (Tudor, 2026-07-30) — close
    // every other open card in the same collection list before toggling
    // this one, so grid/list never shows two panels expanded together.
    if (list) {
      list.querySelectorAll('.am-card[data-am-more]').forEach(function (other) {
        if (other === card) return;
        other.setAttribute('data-am-anim', '');
        other.removeAttribute('data-am-more');
        var otherBtn = other.querySelector('.am-card__more');
        if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
      });
    }
    if (open) {
      card.removeAttribute('data-am-more');
    } else {
      card.setAttribute('data-am-more', '');
    }
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { markReady(); });
  } else {
    markReady();
  }
  // The theme re-renders the collection section on filter / sort / load-more.
  ['filters', 'initFilters', 'collectionLoadMore'].forEach(function (name) {
    window.addEventListener(name, function () { markReady(); });
  });
})();

/* ------------------------------------------------------------------
   Grid/list comutator (runda 9, 2026-07-30)

   Tudor: "Vreau ca pe desktop sa am si list view, cum e acum; dar si un 5
   grid view". List rămâne randarea server-side implicită; grid e o alegere
   client-side, persistată în sessionStorage — NU cart attribute (bug-ul
   vechi: persista silențios peste sesiuni, fără UI să revii la listă).
   sessionStorage e legat de tab + sesiunea de navigare, deci se resetează
   automat la închiderea tab-ului și e mereu reversibil cu un click.

   Linkurile din comutator (.l4vw a, snippets/filters-sorting.liquid) au
   hreful real (?view=grid / ?view=list) ca fallback fără JS — o navigare
   completă, corectă, doar mai lentă. Cu JS activ, preventDefault() + comutare
   instant fără reîncărcare.

   AJAX: filtrarea/sortarea înlocuiește ÎNTREAGA secțiune (formularul de
   sortare CU comutatorul, plus <ul class="l4cl">) — verificat direct în
   assets/custom-async.js (`collectionSection.innerHTML = resultsMarkup...`
   pe `#shopify-section-<id>`, care conține ambele). Deci comutatorul proaspăt
   randat pierde orice stare aplicată doar în DOM și trebuie recorectat după
   fiecare eveniment, la fel ca markReady() de mai sus — motiv pentru care
   applyView() rulează și pe 'filters'/'initFilters'/'collectionLoadMore'.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var STORAGE_KEY = 'am_collection_view';

  function getStoredView() {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function setStoredView(view) {
    try {
      sessionStorage.setItem(STORAGE_KEY, view);
    } catch (e) {}
  }

  function applyView(view) {
    var isGrid = view === 'grid';
    document.documentElement.classList.toggle('am-grid-view', isGrid);
    // The card CSS (am-collection-premium.css) keys its two layouts off the
    // vendor-native pattern `.l4cl.list` vs `.l4cl.am-premium:not(.list)` —
    // NOT off a class this script invents. Server-side rendering always
    // emits `.list` (collection_view is hardcoded 'list' in Liquid — see
    // sections/main-collection.liquid), so switching to grid must actively
    // REMOVE that class, not just add a sibling one, or `:not(.list)` never
    // matches and grid CSS never activates. `.is-grid-view` still gets
    // added too, only as the anchor for the runda-9 disclosure/width rules
    // that are scoped narrowly to avoid touching the vendor's own list CSS.
    document.querySelectorAll('.l4cl.am-premium').forEach(function (list) {
      list.classList.toggle('list', !isGrid);
      list.classList.toggle('is-grid-view', isGrid);
    });
    document.querySelectorAll('.l4vw').forEach(function (toggle) {
      toggle.querySelectorAll('li[class~="active"], li.active').forEach(function (li) {
        li.classList.remove('active');
      });
      var current = toggle.querySelector('a[data-view="' + view + '"]');
      if (current) {
        var li = current.closest('li');
        if (li) li.classList.add('active');
      }
    });
  }

  /* IMPLICIT: grid pe mobil, listă pe desktop (Tudor, 2026-08-13: „vreau ca pe
     mobile version sa fie default in lista de produse grid view; iar cine vrea
     list view sa apese butonul").

     Doar DEFAULT-ul depinde de lăţime — o alegere explicită a utilizatorului
     (orice valoare în sessionStorage) are întâietate la ambele lăţimi, deci
     butonul „Listă" rămâne exact la fel de puternic ca înainte. Asta e şi
     motivul pentru care nu forţăm grid pe mobil necondiţionat: ar face
     comutatorul inutil, exact bug-ul de tip „rămâi blocat pe o vizualizare"
     documentat mai sus (cart attribute-ul vechi).

     1000px = acelaşi prag cu al drawerului de filtre şi al restului temei.
     `matchMedia` cu gardă: pe un browser fără suport cădem pe `list`, adică
     exact comportamentul dinainte — un default nou nu merită o excepţie.

     Nota din snippets/filters-sorting.liquid care spune „grid nu există pe
     mobil/tabletă" e DEPĂŞITĂ: măsurat azi la 375px, comutatorul e
     `display: flex` şi vizibil. Am lăsat-o pe seama unei treceri separate ca
     să nu ating markup-ul comutatorului în aceeaşi modificare. */
  function defaultView() {
    try {
      if (window.matchMedia && window.matchMedia('(max-width: 1000px)').matches) {
        return 'grid';
      }
    } catch (e) {}
    return 'list';
  }

  /* TEST A/B listă vs grilă (desktop > 1000 px), spec
     docs/superpowers/specs/2026-10-21-colectii-test-lista-grila-design.md.
     snippets/am-vizualizare-exp.liquid (în <head>) alocă brațul și definește funcția PURĂ
     `window.amAlegeVizualizarea`; aici o chemăm cu ce citim din pagină. Precedența (?view → alegerea
     clientului din sessionStorage → brațul → grilă sub prag) trăiește în ea, într-un singur loc.
     `url` = VALOAREA parametrului `view`, nu query string-ul. Fără funcția asta (snippet lipsă) rămâne
     comportamentul vechi, mai jos. Brațul NU se scrie niciodată în `am_collection_view`. */
  function latimeMica() {
    try {
      return !!(window.matchMedia && window.matchMedia('(max-width: 1000px)').matches);
    } catch (e) {
      return false;
    }
  }

  /* Cohorta de viewport e fixată O DATĂ pe încărcare, de snippet (window.amVizualizareViewport); expunerea,
     atributul de coș și emițătorul listelor o citesc de acolo, ca numărătorii și numitorul să vină din aceeași
     încărcare chiar dacă fereastra trece de 1000 px mai târziu. Snippet vechi/lipsă → calculul de azi. */
  function viewportFixat() {
    var v = window.amVizualizareViewport;
    if (v === 'gt1000' || v === 'le1000') return v;
    return latimeMica() ? 'le1000' : 'gt1000';
  }

  function testActiv() {
    return window.amVizualizareBrat === 'a' || window.amVizualizareBrat === 'b';
  }

  function alege() {
    var stored = getStoredView();
    if (typeof window.amAlegeVizualizarea === 'function') {
      try {
        var viewUrl = null;
        try { viewUrl = new URLSearchParams(window.location.search).get('view'); } catch (e) {}
        var r = window.amAlegeVizualizarea({
          url: viewUrl,
          stocat: stored,
          brat: window.amVizualizareBrat,
          latimeMica: latimeMica()
        });
        if (r && (r.vizualizare === 'grid' || r.vizualizare === 'list')) return r;
      } catch (e) {}
    }
    if (stored === 'grid' || stored === 'list') return { vizualizare: stored, sursa: 'stocat' };
    return { vizualizare: defaultView(), sursa: 'implicit' };
  }

  function currentView() {
    return alege().vizualizare;
  }

  /* Expunerea (o dată pe încărcare, pe paginile cu listă premium, la ambele lățimi) și atributul de coș
     `_vizualizare` (o dată pe sesiune, doar la prima expunere peste prag). Niciuna nu are voie să
     blocheze sau să strice applyView: totul în try/catch, iar fetch-ul e fire-and-forget.
     `update.js` cu `attributes` face MERGE: `_bf_sort`, atributul sticky și altele rămân neatinse.
     Marcajul de sesiune se scrie DOAR după răspuns ok — un eșec se reîncearcă la următoarea încărcare. */
  var CHEIE_COS = 'am_vizualizare_cos';
  var expus = false;

  function scrieAtributCos(brat) {
    try {
      if (sessionStorage.getItem(CHEIE_COS) === '1') return;
    } catch (e) {}
    if (typeof window.fetch !== 'function') return;
    var radacina = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.fetch(radacina + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _vizualizare: brat } })
    }).then(function (raspuns) {
      if (raspuns && raspuns.ok) {
        try { sessionStorage.setItem(CHEIE_COS, '1'); } catch (e) {}
      }
    }).catch(function () {});
  }

  /* Acordul de analitice, ca în emitator-liste.js (permisAnalytics): fail-closed, orice eroare = fără acord. */
  function analiticePermise() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === true);
    } catch (e) { return false; }
  }

  function publicaExpunere(date) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('audio_monkey:vizualizare_expunere', date);
      }
    } catch (e) {}
  }

  function expune(sursa) {
    var brat = window.amVizualizareBrat;
    var viewport = viewportFixat();
    var peste = viewport === 'gt1000';
    var date = {
      brat: brat,
      viewport: viewport,
      sursa: sursa
    };
    publicaExpunere(date);
    /* Pixelul aruncă evenimentele de dinainte de acord, iar clicurile/coșul de după acord se numără: un
       vizitor care acceptă bannerul DUPĂ încărcare ar ajunge în numărător fără să fie în numitor (rate
       umflate, chiar peste 100%). Dacă acordul nu e dat acum, republicăm aceeași expunere, o singură dată,
       când `visitorConsentCollected` aduce acordul (la fel ca emitator-liste.js). Cu acord la încărcare:
       o singură publicare, fără ascultător. */
    if (!analiticePermise()) {
      try {
        var republicata = false;
        document.addEventListener('visitorConsentCollected', function () {
          if (republicata || !analiticePermise()) return;
          republicata = true;
          publicaExpunere(date);
        });
      } catch (e) {}
    }
    if (peste) {
      try { scrieAtributCos(brat); } catch (e) {}
    }
  }

  // Init on load, and again after every AJAX re-render (fresh markup has no
  // JS-applied state — same reasoning as markReady() above).
  function init() {
    var ales = alege();
    applyView(ales.vizualizare);
    // Clasa anti-clipire pusă de snippet pe <html> (brațul b, desktop): scoasă pe ORICE cale, imediat după
    // primul applyView sau imediat dacă pagina n-are listă — fișierul ăsta se încarcă pe fiecare pagină,
    // iar plasa de 3 s a snippetului nu trebuie să fie niciodată cea care deblochează ceva.
    try { document.documentElement.classList.remove('am-vizualizare-asteapta'); } catch (e) {}
    if (!expus && testActiv() && document.querySelectorAll('.l4cl.am-premium').length) {
      expus = true;
      expune(ales.sursa);
    }
  }

  /* Redimensionare peste/sub prag (1001 → 999 → 1001): implicitul depinde de lățime, deci îl recalculăm.
     `alege()` păstrează precedența: ?view și alegerea clientului bat implicitul și la resize.
     Doar când testul e activ — altfel rămâne comportamentul vechi (fără ascultător). */
  if (typeof window.amAlegeVizualizarea === 'function' && testActiv()) {
    try {
      var mq = window.matchMedia && window.matchMedia('(max-width: 1000px)');
      var laSchimbare = function () { applyView(currentView()); };
      if (mq) {
        if (typeof mq.addEventListener === 'function') mq.addEventListener('change', laSchimbare);
        else if (typeof mq.addListener === 'function') mq.addListener(laSchimbare);
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  ['filters', 'initFilters', 'collectionLoadMore'].forEach(function (name) {
    window.addEventListener(name, init);
  });

  // Delegated click: works on both the first-paint toggle and any AJAX-
  // refreshed copy, without re-binding.
  //
  // CAPTURE phase + stopImmediatePropagation (2026-08-05). The theme binds its
  // OWN handler directly on each `.l4vw a` (custom-async.js:3930-3954), which
  // calls saveCollectionview() → writes the `collection_view` cart attribute and
  // re-fetches the section from the server. `main-collection.liquid:27` hardcodes
  // `collection_view = 'list'`, so that response always comes back as a list and
  // stomps the grid classes we just applied. On desktop the race usually resolved
  // in our favour; on a real phone it did not, which is why Tudor saw the mobile
  // grid toggle "do nothing". Capture runs before the target-phase handler, so
  // stopping propagation here means only one view mechanism is live. Removing
  // this file restores the theme's own behaviour untouched.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.l4vw a[data-view]');
    if (!link) return;
    var view = link.getAttribute('data-view') === 'grid' ? 'grid' : 'list';
    event.preventDefault();
    event.stopImmediatePropagation();
    setStoredView(view);
    applyView(view);
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      if (view === 'grid') {
        url.searchParams.set('view', 'grid');
      } else {
        url.searchParams.delete('view');
      }
      window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    }
  }, true);

  // A shared/bookmarked ?view=grid link should also stick for the rest of
  // this browser session, same as clicking the toggle would.
  (function syncFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var urlView = params.get('view');
    if (urlView === 'grid' || urlView === 'list') {
      setStoredView(urlView);
    }
  })();
})();

/* Custom chat launcher: mutat în assets/am-chat-launcher.js (19.10.2026). */

/* ------------------------------------------------------------------
   Move search icon next to account icon (Tudor, 2026-07-30).

   Markup: #header-inner > .link-btn > a.search-compact — sharing a
   parent with the hamburger trigger, which put both on the left after
   the hamburger-order fix (am-product-title.css, "Header order").
   #header-inner > #nav-user > ul.nav-user holds the account + cart
   triggers as <li> siblings.

   FIRST attempt (CSS-only `display: contents` on .link-btn) confirmed
   NOT to work live — order didn't visually apply. SECOND attempt
   (this file's earlier version) moved the <a> to be a direct child of
   <nav id="nav-user">, i.e. a SIBLING of its <ul>, not a member of
   it — wrong flex context, so it dropped to its own row below the
   ul instead of sitting inline with account/cart (caught from a
   screenshot Tudor sent, not from this session's own checks — the
   earlier verification only measured "is it right of the logo",
   never "is it on the same row as account/cart").

   Fix: the vendor already has a dedicated slot for this —
   `#nav-user > ul > li.search` (screen.css has several rules keyed
   off exactly that selector, e.g. line ~717
   "#search:not(.compact) ~ #nav-user > ul > li.search"). Wrap the
   <a> in an <li class="search"> and insert it as the FIRST <li> of
   #nav-user's <ul>, so it's a proper flex/list item alongside the
   account and cart <li>s instead of a stray sibling of the list. */
(function () {
  'use strict';
  var search = document.querySelector('#header-inner > .link-btn > a.search-compact');
  var navList = document.querySelector('#nav-user > ul');
  if (search && navList) {
    var li = document.createElement('li');
    li.className = 'search';
    li.appendChild(search);
    navList.insertBefore(li, navList.firstChild);
  }
})();

/* PDP policy row breakout offset — scos runda 12 (2026-07-30). Rândul de
   politici a fost mutat dintr-un block al coloanei .f8pr (sticky) într-o
   secțiune proprie de sub main-product (vezi am-pdp-info.css §8), unde
   lățimea completă vine gratis din layout-ul de secțiune — nu mai există
   `.am-pdp-policies-breakout` în DOM, deci acest cod nu mai avea target.
   Istoricul complet al problemei (sticky + breakout) rămâne documentat în
   am-pdp-info.css §8, pentru oricine ar avea nevoie de context similar. */

/* ------------------------------------------------------------------
   PDP swatch price-diff recalculation (Tudor, runda 13, 2026-07-30):
   "-200" sau "+200" în colțul fiecărui swatch, față de varianta SELECTATĂ
   acum — nu față de cea mai ieftină.

   De ce JS și nu doar Liquid la încărcare: lista de swatch-uri e un
   fragment static randat o singură dată de server (`sections/main-product
   .liquid`, blocul `#f8pr-ul-check-1`). Verificat live cu un nod marcat
   (`data-am-probe`) care supraviețuia după click pe alt swatch — DOM-ul
   listei nu e înlocuit la schimbarea variantei, doar prețul principal
   (`.f8pr-price`) și URL-ul se actualizează prin alt mecanism. Fără
   recalculare, etichetele ar rămâne înghețate la valorile de la încărcarea
   paginii, deci greșite după primul click.

   Sursa de adevăr: `data-am-price` (bani, întreg) pe fiecare `<input>` de
   swatch — scris direct din `variant.price` în Liquid, nu derivat din text
   afișat (evită parsarea unui format „9.995 lei" înapoi în număr). Baza de
   comparație e input-ul cu `:checked` la momentul evenimentului `change`.

   Formatarea sumei (fără monedă, fără zecimale inutile) rămâne responsabilitatea
   serverului — JS-ul citește `data-am-money-*` (fracțiuni pre-formatate per swatch,
   scrise tot din Liquid) în loc să reimplementeze regulile de format RON aici. */
(function () {
  'use strict';
  function amRecalcSwatchPriceDiffs(list) {
    var inputs = list.querySelectorAll('.color-swatch input[data-am-price]');
    var checked = list.querySelector('.color-swatch input[data-am-price]:checked');
    if (!checked) return;
    var basePrice = parseInt(checked.getAttribute('data-am-price'), 10);
    if (!isFinite(basePrice)) return;
    inputs.forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label) return;
      // RUNDA 16 (2026-07-30): ancora e `.color-swatch__item`, NU
      // `.variant-image`. Aceasta din urmă are `overflow: hidden` (necesar
      // pentru zoom-ul pozei de variantă) și tăia eticheta — 51px de text
      // într-o cutie de 40px. Aceeași mutare e făcută și în randarea Liquid
      // din sections/main-product.liquid; dacă una din ele rămâne pe vechea
      // ancoră, eticheta redevine tăiată după prima schimbare de variantă.
      // Detalii + măsurători: am-pdp-info.css §2b.
      var cell = label.querySelector('.color-swatch__item');
      if (!cell) return;
      var existing = cell.querySelector('[data-am-price-diff]');
      var price = parseInt(input.getAttribute('data-am-price'), 10);
      if (!isFinite(price) || price === basePrice) {
        if (existing) existing.remove();
        return;
      }
      var diff = price - basePrice;
      var text = (diff > 0 ? '+' : '-') + amFormatMoneyNoCurrency(Math.abs(diff));
      if (!existing) {
        existing = document.createElement('span');
        existing.className = 'am-swatch-price-diff';
        existing.setAttribute('data-am-price-diff', '');
        cell.appendChild(existing);
      }
      existing.textContent = text;
    });
  }
  // Formatare fără currency, fără zecimale-.00 — replică simplă a filtrului
  // Liquid `money_without_trailing_zeros`. Banii vin din `data-am-price` în
  // cea mai mică unitate monetară (bani), la fel ca `variant.price`.
  function amFormatMoneyNoCurrency(cents) {
    var units = cents / 100;
    var rounded = Math.round(units);
    var isWhole = Math.abs(units - rounded) < 0.005;
    var formatted = isWhole ? rounded.toString() : units.toFixed(2).replace('.', ',');
    return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  document.querySelectorAll('.am-swatch-compact-pdp').forEach(function (list) {
    amRecalcSwatchPriceDiffs(list);
    list.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[data-am-price]')) {
        amRecalcSwatchPriceDiffs(list);
      }
    });
  });
})();

/* ------------------------------------------------------------------
   PDP SKU — „Cod produs" urmează varianta selectată (Tudor, 2026-08-12).

   Aceeași cauză ca la price-diff de mai sus, deci aceeași soluție: lista de
   swatch-uri e un fragment static randat o dată de server, iar secțiunea NU
   se re-randează la schimbarea variantei (nu există fetch pe `?section_id=`
   în main-product.liquid — doar `f8pr-fallback-id-input`). Fără asta, codul
   ar rămâne cel al variantei din URL după orice click pe altă culoare.

   Miza e mai mare decât la etichetele de preț: un preț greșit se vede, un cod
   de produs greșit nu — ajunge în e-mailul de comandă sau în cererea de
   service și abia acolo se descoperă.

   Sursa de adevăr: `data-am-sku` din harta randată de `am-pdp-sku.liquid`,
   scrisă direct din `variant.sku`, nu text afișat re-parsat. Dacă varianta
   nouă nu are SKU, linia se ascunde în loc să rămână cu valoarea veche —
   un cod care nu se schimbă la click arată exact ca unul corect. */
(function () {
  'use strict';
  var line = document.querySelector('[data-am-sku-line]');
  var map = document.querySelector('[data-am-sku-map]');
  if (!line || !map) return;

  function amUpdateSku(variantId) {
    // Se re-interoghează la fiecare apel, nu o singură dată la load: tema
    // re-randează blocul de variante, deci nodurile pot fi înlocuite.
    var curLine = document.querySelector('[data-am-sku-line]');
    var curMap = document.querySelector('[data-am-sku-map]');
    if (!curLine || !curMap) return;
    var curValue = curLine.querySelector('[data-am-sku-value]');
    if (!curValue) return;
    var node = curMap.querySelector('[data-am-sku-variant="' + variantId + '"]');
    if (!node) return;
    var sku = (node.getAttribute('data-am-sku') || '').trim();
    curLine.hidden = sku === '';
    if (sku) curValue.textContent = sku;
  }

  // DELEGARE PE `document`, nu binding pe noduri (bug găsit 2026-08-21 pe
  // cablurile cu variante de lungime: codul se schimba O SINGURĂ dată, apoi
  // rămânea înghețat la ultima valoare, indiferent câte lungimi mai încercai).
  //
  // CAUZA: la fiecare schimbare de variantă tema înlocuiește nodul
  // `select[name="id"]` (verificat live: `oldSelect.isConnected === false`,
  // nodul nou !== cel vechi). Listener-ul era pus o singură dată, la load,
  // pe nodul de-atunci — după primul re-render el asculta un nod detașat,
  // iar garda `data-am-sku-bound` dispărea odată cu el, deci nici nu se
  // re-lega. Prima schimbare mergea (nodul inițial era încă legat), toate
  // celelalte, nu — exact tiparul raportat.
  //
  // Delegarea pe `document` e imună la înlocuirea nodurilor: ascultăm faza
  // de capture, deci prindem `change` chiar dacă tema oprește propagarea.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    // Swatch-uri de culoare: `input[value="<variant.id>"]`.
    // Select-ul nativ (produse fără swatch-uri, ex. cabluri pe lungime).
    if (t.matches('.am-swatch-compact-pdp input[value]') || t.matches('select[name="id"]')) {
      amUpdateSku(t.value);
    }
  }, true);
})();

/* ------------------------------------------------------------------
   PDP main gallery — înălțimea urmează poza (Tudor, runda 16, 2026-07-30):
   „e un gap ridicol de mare in afara pozei, atat sus si jos... vreau ca
   carouselul de poze sa atinga linia pozei de sus".

   ⚠️ ACEST BLOC INVERSEAZĂ FIX-UL DIN RUNDA 15, care era construit pe o
   diagnoză greșită. Atunci am scris aici că „cutia 4:5 e deja corectă și NU
   produce gol", am dat vina exclusiv pe `autoHeight` și am declarat restul
   „geometrie ireductibilă". Nota aceea se contrazicea singură: măsurase
   „798px container pentru 638px imagine", iar 798 = 638 × 1.25 — adică fix
   cutia `padding-top: calc(var(--ratio) * 100%)` pe care o declara nevinovată.

   Cauza reală e în CSS (`.li`, screen.css:2812) și e reparată acum în
   am-pdp-info.css §7b — vezi acolo măsurătorile complete și de ce `.auto`
   a fost testat și respins. Odată ce cutia nu mai e fixă, `autoHeight`
   devine NECESAR, nu dăunător: fără el `.swiper-wrapper` ar rămâne la
   înălțimea celui mai înalt slide (`align-items: stretch`), iar golul s-ar
   muta din slide în wrapper în loc să dispară. Verificat live: cu CSS-ul
   nou + autoHeight pornit, gol = 0px pe toate slide-urile măsurate,
   inclusiv pe o sursă de altă dimensiune (748×748); galeria scade de la
   899px la 735px, thumbnail-urile rămân 66×55px.

   `create_slider` (custom.js:1756) pornește galeria cu `autoHeight: true`,
   deci în mod normal nu ar fi nimic de făcut — dar re-aplicăm explicit ca
   să fim imuni dacă rularea anterioară a lăsat instanța cu flag-ul stins,
   și pentru că avem oricum nevoie de `update()` după schimbarea de CSS.

   LAZY LOADING: slide-urile ne-încărcate raportează înălțime 0 (măsurat:
   `naturalWidth: 0` pe slide-urile 4+ la prima randare), deci un singur
   `update()` la init calculează greșit pentru ele. De aceea ascultăm
   `load` pe fiecare `<img>` din galerie și re-calculăm. `{ once: true }` ca
   să nu se acumuleze handlere; imaginile deja complete sunt sărite.

   ⚠️ Scope: fișierul se încarcă din theme.liquid pe TOATĂ tema, iar `.l4pr`
   e folosit și de `section-featured-product.liquid` (activ pe
   `templates/page.colection-page.json`). Verificarea de body class
   (`/\btemplate-product\b/`, aceeași ca `amWhenBrowsing` din am-chat-launcher.js) ține
   modificarea strict pe PDP — la fel ca selectorul CSS pereche. */
(function () {
  'use strict';
  if (!/\btemplate-product\b/.test(document.body.className)) return;

  var amGalleryOuter = null;

  function amSyncGalleryHeight() {
    var swiper = amGalleryOuter ? amGalleryOuter.swiper : null;
    if (!swiper) return;
    swiper.params.autoHeight = true;
    swiper.update();
  }

  function amInitGalleryHeight() {
    amGalleryOuter = document.querySelector('.l4pr.s4wi .swiper-outer, .l4pr .swiper-outer');
    if (!amGalleryOuter || !amGalleryOuter.swiper) return false;

    amSyncGalleryHeight();

    amGalleryOuter.querySelectorAll('img').forEach(function (img) {
      if (img.complete && img.naturalWidth) return;
      img.addEventListener('load', amSyncGalleryHeight, { once: true });
    });

    return true;
  }

  if (amInitGalleryHeight()) return;
  var amGalleryTries = 0;
  var amGalleryTimer = setInterval(function () {
    amGalleryTries += 1;
    if (amInitGalleryHeight() || amGalleryTries > 40) {
      clearInterval(amGalleryTimer);
    }
  }, 150);
})();

/* ------------------------------------------------------------------
   Resigilate — panoul „Verifică disponibilitate" (Tudor, runda 16,
   2026-07-30): „as vrea un pop up cu : intreaba chiar acum consultantul
   online; lasan'e datele tale si revenim noi cu un telefon ; si noi sa
   primim nr lor e telefon si produsul despre care erau interesati".

   Canalul e WhatsApp pentru ambele butoane (ales explicit de Tudor: „ok
   momenta pune-l pe whatsapp/telefon"). Nu există backend: formularul de
   callback nu face POST nicăieri, ci compune un mesaj WhatsApp cu numele și
   telefonul introduse, plus produsul și culoarea. Vezi snippets/am-openbox-ask.liquid.

   DESCHIDEREA PANOULUI: tema expune panourile prin `openPanel(id)`, dar
   funcția e locală în custom-async.js (nu e pe `window`). Mecanismul public
   e atributul `data-panel` pe o ancoră, legat la init. Butonul nostru e un
   `<button>` randat de Liquid, deci deleg pe `document` și declanșez panoul
   apăsând programatic o ancoră ascunsă cu `data-panel` — singura cale care
   nu necesită modificarea fișierului de vendor.

   ⚠️ Delegare pe `document`, nu binding per-buton: blocul de resigilate e
   re-randat de schimbarea de variantă (custom-async.js face `replaceChild`
   pe zone din secțiune), iar handlerele legate la init ar muri odată cu
   markup-ul. Delegarea supraviețuiește oricărei re-randări. */
(function () {
  'use strict';
  if (!/\btemplate-product\b/.test(document.body.className)) return;

  var amAskPanel = document.getElementById('am-openbox-ask');
  if (!amAskPanel) return;

  var amAskState = { product: '', variant: '' };

  function amAskTemplate(key, vars) {
    // Replică minimală a interpolării Liquid `{{ x }}` din locale, ca textele
    // să rămână în ro-RO.json (traductibile), nu hardcodate în JS.
    var raw = amAskPanel.getAttribute('data-am-tpl-' + key) || '';
    return raw.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      return vars[name] != null ? vars[name] : '';
    });
  }

  function amAskWaLink(message) {
    var number = amAskPanel.getAttribute('data-am-wa') || '';
    return 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
  }

  function amAskRefresh() {
    var label = amAskPanel.querySelector('[data-am-ask-product]');
    if (label) {
      label.textContent = amAskState.product +
        (amAskState.variant ? ' — ' + amAskState.variant : '');
    }
    var wa = amAskPanel.querySelector('[data-am-ask-wa]');
    if (wa) {
      wa.setAttribute('href', amAskWaLink(amAskTemplate('message', {
        product: amAskState.product,
        variant: amAskState.variant
      })));
    }
  }

  // Ancoră ascunsă: singurul declanșator public al sistemului de panouri.
  var amAskOpener = document.createElement('a');
  amAskOpener.setAttribute('data-panel', 'am-openbox-ask');
  amAskOpener.setAttribute('href', '#am-openbox-ask');
  amAskOpener.setAttribute('aria-hidden', 'true');
  amAskOpener.setAttribute('tabindex', '-1');
  amAskOpener.style.display = 'none';
  document.body.appendChild(amAskOpener);

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-am-openbox-ask]') : null;
    if (!trigger) return;
    e.preventDefault();
    amAskState.product = trigger.getAttribute('data-am-product') || '';
    amAskState.variant = trigger.getAttribute('data-am-variant') || '';
    amAskRefresh();
    amAskOpener.click();
  });

  amAskPanel.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-am-ask-form]') : null;
    if (!form) return;
    e.preventDefault();
    var name = form.querySelector('#am-openbox-ask-name');
    var phone = form.querySelector('#am-openbox-ask-phone');
    // Validare minimă: fără telefon, mesajul nu are valoare pentru magazin.
    if (!phone || !phone.value.trim()) {
      if (phone) phone.focus();
      return;
    }
    var url = amAskWaLink(amAskTemplate('message-callback', {
      name: name ? name.value.trim() : '',
      phone: phone.value.trim(),
      product: amAskState.product,
      variant: amAskState.variant
    }));
    window.open(url, '_blank', 'noopener');
  });
})();

/* ------------------------------------------------------------------
   Bullet-uri pe desktop: „Vezi mai multe detalii" doar când chiar taie
   (2026-08-05, Tudor: „5 rânduri de text e maximul; dacă se depăşeşte,
   facem cu view more").

   CSS-ul (§ 12.3) rezervă o înălţime fixă de 5 rânduri pentru fiecare
   panou de bullet-uri, ca toate cardurile de pe rând să fie egale. Aici
   se decide care carduri au nevoie de control: se compară înălţimea
   naturală a conţinutului cu cea rezervată.

   `data-am-hl-measured` e pus INDIFERENT de rezultat: CSS-ul lasă
   înălţimea liberă până când apare atributul, ca un client fără JS să nu
   rămână cu text tăiat şi fără buton (acelaşi contract de îmbunătăţire
   progresivă ca la disclosure-ul de mobil de mai sus).

   Se re-măsoară la resize şi după schimbările de secţiune ale temei —
   lăţimea cardului decide câte rânduri ocupă un bullet.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 761px)';

  function measure(root) {
    var scope = root || document;
    var desktop = window.matchMedia(DESKTOP).matches;
    scope.querySelectorAll('.l4cl.list .am-card .am-card__highlights').forEach(function (panel) {
      var card = panel.closest('.am-card');
      if (!card) return;
      if (!desktop) {
        // Pe mobil regulile sunt cele vechi (panou colapsat, buton mereu
        // vizibil), deci atributele astea n-au ce căuta acolo.
        card.removeAttribute('data-am-hl-overflow');
        card.removeAttribute('data-am-hl-measured');
        return;
      }
      // Măsurarea are sens doar cu panoul închis: deschis, înălţimea e `auto`
      // şi scrollHeight ar fi mereu egal cu clientHeight.
      if (card.hasAttribute('data-am-more')) return;
      card.setAttribute('data-am-hl-measured', '');
      // 1px toleranţă: înălţimile de rând sub-pixel pot da diferenţe de 0,5px
      // pe carduri care în realitate încap exact.
      if (panel.scrollHeight > panel.clientHeight + 1) {
        card.setAttribute('data-am-hl-overflow', '');
      } else {
        card.removeAttribute('data-am-hl-overflow');
      }
    });
  }

  function schedule() {
    // Măsurare sincronă: `clientHeight` forţează oricum recalcularea layout-ului,
    // deci stilurile sunt aplicate în momentul citirii.
    //
    // ⚠️ Deliberat FĂRĂ `requestAnimationFrame`: într-un tab care nu e vizibil
    // (previzualizarea din panou, o filă de fundal) rAF e suspendat şi callback-ul
    // nu rulează niciodată — panourile rămâneau nemăsurate, deci fără plafon şi
    // fără buton. Prins exact aşa la verificare.
    measure();
    // O a doua trecere după ce se aşază fonturile/imaginile, fără să depindă de
    // vizibilitatea filei.
    setTimeout(measure, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  // Fonturile schimbă lăţimea textului, deci şi numărul de rânduri.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(schedule, 150);
  });
  ['filters', 'initFilters', 'collectionLoadMore'].forEach(function (name) {
    window.addEventListener(name, schedule);
  });
})();
